import {AnnotationCollection} from '@/api';

function staleError() {
  const error = new Error('AI training report request is stale.');
  error.code = 'STALE_AI_TRAINING_REPORT';
  return error;
}

export async function fetchAllTrainingAnnotationsForTerm({
  projectId,
  imageId,
  termId,
  pageSize = 100,
  Collection = AnnotationCollection,
  isCurrent = () => true
}) {
  const items = [];
  let page = 0;
  let total = null;
  do {
    if (!isCurrent()) {
      throw staleError();
    }
    const collection = await new Collection({
      nbPerPage: pageSize,
      project: projectId,
      images: String(imageId),
      term: termId,
      reviewed: false,
      multipleTerm: false,
      noTerm: false,
      showUser: true,
      showAlgo: true,
      excludeJobLinkedAlgo: true,
      showDefault: true,
      showWKT: true,
      showTerm: true,
      showGIS: true
    }).fetchPage(page);
    if (!isCurrent()) {
      throw staleError();
    }
    const pageItems = Array.isArray(collection.array) ? collection.array : [];
    items.push(...pageItems);
    const parsedTotal = Number(collection.totalNbItems);
    total = Number.isFinite(parsedTotal) ? parsedTotal : items.length;
    page++;
  } while (items.length < total);
  return items;
}
